class FuncHelper {
  static get emptyFunc() {
    return () => null
  }
}

export default FuncHelper
